import styled, { createGlobalStyle } from 'styled-components';

import Button from 'basics/buttons/Button';

import { cardBoxShadow, flexAllCenter, respondDown, textEllipsis } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Wrapper = styled.div`
    position: relative;
    height: 100%;
`;

export const AccountBlockContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const AccountBlockWeb = styled(AccountBlockContainer)<{ $isMenuOpen: boolean }>`
    border: none;
    background: transparent;
    font: inherit;
    text-align: left;
    padding: 2.4rem;
    ${({ $isMenuOpen }) => $isMenuOpen && cardBoxShadow};
    cursor: pointer;

    &:disabled {
        cursor: default;
    }

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const AccountBlockMobile = styled(AccountBlockContainer)`
    display: none;

    ${respondDown(Breakpoints.md)`
        display: flex;
    `}
`;

export const IconsBlock = styled.div`
    position: relative;
    height: 4.8rem;
    width: 4.8rem;
`;

export const AppIcon = styled.img`
    height: 1.6rem;
    width: 1.6rem;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 0;

    ${respondDown(Breakpoints.md)`
       height: 1.1rem;
       width: 1.1rem;
    `}
`;

export const AccountAddresses = styled.div`
    margin-left: 0.8rem;
    margin-right: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${respondDown(Breakpoints.lg)`
        display: none;
    `}
`;

export const Arrow = styled.div<{ $isMenuOpen: boolean }>`
    transform-origin: center;
    transform: ${({ $isMenuOpen }) => ($isMenuOpen ? 'rotate(180deg)' : 'none')};
    transition: transform linear 200ms;
    height: 1.6rem;
    width: 1.6rem;

    ${respondDown(Breakpoints.md)`
          display: none;
      `}
`;

export const AccountFederation = styled.div`
    color: ${COLORS.textPrimary};
    line-height: 2rem;
    margin-bottom: 0.2rem;
    max-width: 25rem;
    ${textEllipsis};
`;

export const AccountPublic = styled.div`
    color: ${COLORS.textGray};
    line-height: 2rem;
`;

export const SignInButton = styled(Button)`
    width: 12rem;
    margin-left: 1.6rem;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const MobileMenu = styled.div`
    display: none;
    cursor: pointer;
    padding: 1rem;
    box-sizing: border-box;
    margin-right: -1rem;

    ${respondDown(Breakpoints.md)`
        display: block;
    `}
`;

export const MobileMenuButton = styled.div`
    ${flexAllCenter};
    height: 4.8rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLORS.textPrimary};
    background: ${COLORS.controlBackground};
    border: 0.1rem solid ${COLORS.controlBorder};
    border-radius: 0.6rem;
    padding: 0 1.6rem;

    &:hover {
        background: ${COLORS.controlHover};
        color: ${COLORS.purple500};
    }

    svg {
        margin-right: 0.8rem;
    }
`;

export const CloseMenuButton = styled.div`
    ${flexAllCenter};
    height: 4.8rem;
    width: 4.8rem;
    background-color: ${COLORS.surface};
    ${cardBoxShadow};
    border-radius: 0.5rem;
`;

export const BodyStyle = createGlobalStyle`
    html {
        overflow: hidden;
    }
    body {
      overflow: hidden;
    }
`;
